import React, { FC } from 'react'

import { useHelpCenterButton } from '../hooks/useHelpCenterButton'
import { HelpCenterButtonView } from './HelpCenterButtonView'
import { THelpCenterButton } from '../types/HelpCenterButton.types'

export const HelpCenterButton: FC<THelpCenterButton> = ({ icon, buttonText }) => {
  const { onClick, showBottomSheet } = useHelpCenterButton()

  return (
    <HelpCenterButtonView
      icon={icon}
      buttonText={buttonText}
      onClick={onClick}
      showBottomSheet={showBottomSheet}
    />
  )
}
